(function () {

    function Device() {
        var os = this.os = {}, browser = this.browser = {},
            ua = navigator.userAgent,

            mobileApp=ua.match(/pcloudApp?/)|| ua.match(/linkitApp?/),
            webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
            android = ua.match(/(Android);?[\s\/]+([\d.]+)?/),
            osx = !!ua.match(/\(Macintosh\; Intel /),
            ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
            ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
            iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
            webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
            touchpad = webos && ua.match(/TouchPad/),
            kindle = ua.match(/Kindle\/([\d.]+)/),
            silk = ua.match(/Silk\/([\d._]+)/),
            blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
            bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
            rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
            playbook = ua.match(/PlayBook/),
            uc = ua.match(/UCBrowser\/([\w.\s]+)/),
            chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
            firefox = ua.match(/Firefox\/([\d.]+)/),
            ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
            webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
            safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/),
            orientation = Math.abs(window.orientation);

        if (browser.webkit = !!webkit) {
            browser.version = webkit[1];
        }

        if (android) {
            os.android = true;
            os.version = android[2];
        }
        if (iphone && !ipod) {
            os.ios = os.iphone = true;
            os.version = iphone[2].replace(/_/g, '.');
        }
        if (ipad) {
            os.ios = os.ipad = true;
            os.version = ipad[2].replace(/_/g, '.');
        }
        if (ipod) {
            os.ios = os.ipod = true;
            os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
        }
        if (webos) {
            os.webos = true;
            os.version = webos[2];
        }
        if (touchpad) {
            os.touchpad = true;
        }
        if (blackberry) {
            os.blackberry = true;
            os.version = blackberry[2];
        }
        if (bb10) {
            os.bb10 = true;
            os.version = bb10[2];
        }
        if (rimtabletos) {
            os.rimtabletos = true;
            os.version = rimtabletos[2];
        }
        if (playbook) {
            browser.playbook = true;
        }
        if (uc) {
            os.uc = true;
            os.ucversion = uc[1];
        }
        if (kindle) {
            os.kindle = true;
            os.version = kindle[1];
        }
        if (silk) {
            browser.silk = true;
            browser.version = silk[1];
        }
        if (!silk && os.android && ua.match(/Kindle Fire/)) {
            browser.silk = true;
        }
        if (orientation !== 90) {
            os.protrait = true;
        }
        if (orientation === 90) {
            os.landscape = true;
        }

        if (chrome) {
            browser.chrome = true;
            browser.version = chrome[1];
        }
        if (firefox) {
            browser.firefox = true;
            browser.version = firefox[1];
        }
        if (ie) {
            browser.ie = true;
            browser.version = ie[1];
        }
        if (safari && (osx || os.ios)) {
            browser.safari = true;
            if (osx) {
                browser.version = safari[1];
            }
        }
        if (webview) {
            browser.webview = true;
        }
        if (mobileApp){
            os.isAppmobile=true;
        }
        else{
            os.isAppmobile=false;
        }

        os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
        (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
        os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 ||
        (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
        (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
    }

    Device.prototype.isMobile = function () {
        return  (this.os.phone || this.os.ios || this.os.android || this.os.iphone)&&(!this.os.isAppmobile)&&(!this.os.ipad);
    };
    Device.prototype.isMobileApp = function () {
        return  this.os.isAppmobile;
    };
    Device.prototype.isIpad = function () {
        return  this.os.ipad;
    };
    Device.prototype.redirect = function (url) {
        window.location.href = url + window.location.search + window.location.hash;
    };

    Device.prototype.redirectWithParams = function (url, errorInfo) {
        var params = "";
        if(window.location.search.length === 0 && errorInfo !== "null")
        {
            params = "?iamErrorInfo=" + errorInfo;
        }
        else
        {
            var errorIndex = window.location.search.indexOf("iamErrorInfo=");
            var search = window.location.search.split('?')[1];

            if(search==null){
                window.location.href = url + window.location.hash;
                return;
            }

            var ulrParams = search.split('&');

            //替换
            if(errorIndex != -1 && errorInfo !== "null")
            {
                for(var i=0; i<ulrParams.length; i++)
                {
                    if(ulrParams[i].split('=')[0] === "iamErrorInfo")
                    {
                        ulrParams[i] = "iamErrorInfo=" + errorInfo;
                    }
                }

                params = "?" + ulrParams.join('&');
            }
            //删除参数
            else if(errorIndex != -1)
            {
                for(var i=0; i<ulrParams.length; i++)
                {
                    if(ulrParams[i].split('=')[0] !== "iamErrorInfo")
                    {
                        params = params + ulrParams[i] + '&';
                    }
                }

                params = "?" + params.substr(0,params.length-1);
            }
            else if(errorInfo !== "null")
            {
                params = window.location.search + "&iamErrorInfo=" + errorInfo;
            }
            else{
                params = window.location.search;
            }
        }
        
        window.location.href = url + params + window.location.hash;
    };

    if (!window.IAM) {
        window.IAM = {};
    }
    window.IAM.Device = Device;

})();


// WEBPACK FOOTER //
// ./public/base/pre/platformChecker.js